import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/help-and-feedback/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { HelpAndFeedbackFeature } from '@framework/workbench/ui/help-and-feedback/help-and-feedback-feature';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import {
    TitlebarFileMenuConfig,
    ToolbarFileMenuConfig,
} from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

@Controller({ menuItems: MENU_CONFIGS })
export class HelpAndFeedbackController {
    constructor(private readonly feature: HelpAndFeedbackFeature) {
    }

    @Menu(ActionType.HELP_FEEDBACK, 'popUpStyle')
    @Menu(ActionType.PRIVACY, 'popUpStyle')
    public popupStyle() {
        return {
            minWidth: '194px',
        };
    }

    @Menu(ActionType.HELP, 'onClick')
    public handleClickHelp() {
        this.feature.showHelp();
    }

    @Menu(ActionType.REPORT, 'onClick')
    public handleClickReport() {
        this.feature.showReport();
    }

    @Menu(ActionType.ACCUSATION, 'onClick')
    public handleClicAccusation() {
        this.feature.showAccusation();
    }

    @Menu(ActionType.PRIVACY_POLICY, 'onClick')
    public handleClickPrivacyPolicy() {
        this.feature.showPrivacyPolicy();
    }

    @Menu(ActionType.THIRD_PARTY_DATA_SHARING, 'onClick')
    public handleClickThirdPartyDataSharing() {
        this.feature.showThirdPartyDataSharing();
    }

    @Menu(ActionType.THIRD_AUTHORIZATION_MANAGEMENT, 'onClick')
    public handleClickThirdAuthorizationManagement() {
        this.feature.showThirdAuthorizationManagement();
    }

    @Menu(ActionType.PERSONAL_INFO_COLLECTION, 'onClick')
    public handleClickPersonalInfoCollection() {
        this.feature.showPersonalInfoCollection();
    }

    @Menu(ActionType.INFRINGEMENT, 'onClick')
    public handleClickInfringement() {
        this.feature.showInfringement();
    }

    @Menu(ActionType.APPEAL, 'onClick')
    public handleClickAppeal() {
        this.feature.showAppeal();
    }

    @Menu(ActionType.ABOUT, 'onClick')
    public handleClickAbout() {
        this.feature.showAbout();
    }

    @Menu(ActionType.COMMUNITY_CONVENTION, 'onClick')
    public handleClickCommunityConvention() {
        this.feature.showCommunityConvention();
    }

    @Menu(ActionType.SHORTCUT_KEY, 'onClick')
    public handleClickShortcutKey() {
        this.feature.showShortCutKeyPanel();
    }

    @Menu(ActionType.HELP_FEEDBACK, 'shouldHide')
    public handleHide() {
        const isSimpleMode = !!(appConfigInstance.getConfig(TitlebarFileMenuConfig.simplifyMode as any) ?? false);
        const showHelp = !!(appConfigInstance.getConfig(ToolbarFileMenuConfig.helpFeedback as any) ?? true);
        return isSimpleMode || !showHelp;
    }

    @Menu(ActionType.SLIDE_VERSION, 'shouldHide')
    public handleSlideVersionHide() {
        return false;
    }

    @Menu(ActionType.HELP, 'shouldHide')
    public handleSlideHelpHide() {
        // pc端小程序隐藏帮助中心入口
        return (browser.isPc && browser.isMiniProgram);
    }
}
